import { render } from "./userCenterView.vue?vue&type=template&id=263b1a83&scoped=true"
import script from "./userCenterView.vue?vue&type=script&lang=js"
export * from "./userCenterView.vue?vue&type=script&lang=js"

import "./userCenterView.vue?vue&type=style&index=0&id=263b1a83&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-263b1a83"

export default script